import React, { useContext, useEffect } from 'react';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logoutClearStore } from '../../../actions/auth';
import Loader from '../../common/Loader';
import { useTranslation } from 'react-i18next';
import { AuthContext, authinitialState } from '../../../Contexts';

const LoggedOut = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const context = useContext(AuthContext);

  useEffect(() => {
    context?.setUserData(authinitialState);
    const urlParams = new URLSearchParams(
      typeof window !== 'undefined' && window.location.search
    );
    _.eraseCookie('user-name');
    _.eraseCookie('usertoken');
    _.eraseCookie('fname');
    _.eraseCookie('lname');
    _.eraseCookie('email');
    _.eraseCookie('birthDate');
    _.eraseCookie('sessionId');
    dispatch(logoutClearStore());
    if (urlParams && urlParams.has('isSessionInvalid'))
      history.push('/?isSessionInvalid=true');
    else i18n?.language === 'es' ? history.push('/es') : history.push('/');
  }, []);
  return (
    <div className="logOutRow">
      <Loader />
    </div>
  );
};
export default LoggedOut;
